import { render, staticRenderFns } from "./valorAdmin.vue?vue&type=template&id=108368f3&scoped=true"
import script from "./valorAdmin.vue?vue&type=script&lang=js"
export * from "./valorAdmin.vue?vue&type=script&lang=js"
import style0 from "./valorAdmin.vue?vue&type=style&index=0&id=108368f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108368f3",
  null
  
)

export default component.exports